import { getService } from "~/modules/dioc"
import { environmentsStore } from "~/newstore/environments"
import { platform } from "~/platform"
import { WorkspaceService } from "~/services/workspace.service"
import { KernelInterceptorService } from "~/services/kernel-interceptor.service"
import {
  RuntimeSecretContext,
  RuntimeSecretResolutionError,
} from "./runtime-secrets"

export function captureRuntimeSecretContext(): RuntimeSecretContext | null {
  if (!platform.runtimeSecrets) return null
  const workspaceService = getService(WorkspaceService)
  const workspace = workspaceService.currentWorkspace.value
  if (workspace.type !== "team") return null
  const teamID = workspace.teamID
  const userID = platform.auth.getCurrentUser()?.uid
  const selected = environmentsStore.value.selectedEnvironmentIndex
  const environmentID =
    selected.type === "TEAM_ENV" && selected.teamID === teamID
      ? selected.teamEnvID
      : ""
  return {
    api: platform.runtimeSecrets,
    teamID,
    environmentID,
    assertCurrent: () => {
      const current = workspaceService.currentWorkspace.value
      const env = environmentsStore.value.selectedEnvironmentIndex
      const currentEnvID =
        env.type === "TEAM_ENV" && env.teamID === teamID ? env.teamEnvID : ""
      if (
        current.type !== "team" ||
        current.teamID !== teamID ||
        currentEnvID !== environmentID ||
        platform.auth.getCurrentUser()?.uid !== userID
      ) {
        throw new RuntimeSecretResolutionError(
          "The workspace, environment or login changed. Send the request again."
        )
      }
    },
    assertTransport: () => {
      const interceptorID = getService(KernelInterceptorService).current.value
        ?.id
      if (interceptorID !== "browser" && interceptorID !== "agent") {
        throw new RuntimeSecretResolutionError(
          "Select the Browser or Agent interceptor to send requests using runtime credentials."
        )
      }
    },
  }
}
